import { render, staticRenderFns } from "./UrbanismRegulationsListTable.vue?vue&type=template&id=3ddc8168&"
import script from "./UrbanismRegulationsListTable.vue?vue&type=script&lang=js&"
export * from "./UrbanismRegulationsListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports